import * as React from 'react'

import {
  IFormValidation,
  FormBlueprint,
} from '../interfaces/components/dynamic-form'
import * as DynamicFormHelpers from '../lib/dynamic-form/helpers'
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  Icon,
  styled,
} from '@design/pt-ui'
import ValidationMessages from './ValidationMessages'
import { Close as CloseIcon } from '@mui/icons-material'

import { translateWithUserLocale } from '../utils/i18n'

const ErrorCnt = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

const ValidationCnt = styled('div')({
  display: 'flex',
  flexFlow: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  marginLeft: 15,
  paddingRight: 15,
  borderRadius: 4,
  transition: '0.5s',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
})

interface IState {
  dialogShown: boolean
}

interface IProps {
  blueprint: FormBlueprint | null
  validation: IFormValidation
}

function ValidationInfo(props: IProps) {
  const [state, setState] = React.useState<IState>({
    dialogShown: false,
  })

  const closeValidationDialog = () => {
    setState({
      dialogShown: false,
    })
  }

  const openValidationDialog = () => {
    const numberOfWarnings = DynamicFormHelpers.countWarningsAndErrors(
      props.validation,
    ).warnings
    const numberOfErrors = DynamicFormHelpers.countWarningsAndErrors(
      props.validation,
    ).errors
    if (numberOfWarnings > 0 || numberOfErrors > 0) {
      setState({
        dialogShown: true,
      })
    }
  }

  const numberOfWarnings = DynamicFormHelpers.countWarningsAndErrors(
    props.validation,
  ).warnings
  const numberOfErrors = DynamicFormHelpers.countWarningsAndErrors(
    props.validation,
  ).errors

  const errors =
    numberOfErrors > 0 ? (
      <ErrorCnt>
        <Icon sx={{ color: 'error.main', mr: 2, ml: 2 }}>warning</Icon>
        <Box
          component="span"
          sx={{ fontSize: 14, fontWeight: 700, color: 'error.main' }}>
          {numberOfErrors === 1
            ? numberOfErrors + ' ' + translateWithUserLocale('error')
            : numberOfErrors + ' ' + translateWithUserLocale('errors')}
        </Box>
      </ErrorCnt>
    ) : null

  const warnings =
    numberOfWarnings > 0 ? (
      <ErrorCnt>
        <Icon sx={{ color: 'warning.light', mr: 2, ml: 2 }}>priority_high</Icon>
        <Box
          component="span"
          sx={{ fontSize: 14, fontWeight: 700, color: 'warning.main' }}>
          {numberOfWarnings === 1
            ? numberOfWarnings + ' ' + translateWithUserLocale('warning')
            : numberOfWarnings + ' ' + translateWithUserLocale('warnings')}
        </Box>
      </ErrorCnt>
    ) : null

  const fields = props.validation.fields

  const messages =
    props.blueprint === null ? undefined : (
      <ValidationMessages fields={fields} blueprint={props.blueprint} />
    )

  return (
    <div>
      <ValidationCnt onClick={openValidationDialog}>
        {errors}
        {warnings}
      </ValidationCnt>
      <Dialog
        disableRestoreFocus={true}
        open={state.dialogShown}
        sx={{ minWidth: 320 }}
        onClose={closeValidationDialog}
        maxWidth="md">
        <DialogTitle sx={{ marginRight: '35px', paddingBottom: '10px' }}>
          {translateWithUserLocale('errors_and_warnings_overview')}
          <IconButton
            sx={{
              position: 'absolute',
              right: 1,
              top: 12,
              color: 'grey.500',
            }}
            onClick={closeValidationDialog}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row',
              justifyContent: 'left',
            }}>
            <div>{messages}</div>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  )
}
export default ValidationInfo
